import React, { ReactElement, ReactNode } from 'react';
import { getPageLayout } from '@/features';
import { FaqPage } from '@/features/faq-page';
import { PageType } from '@/types/page';

export default function Faq(): ReactNode {
  return <FaqPage />;
}
Faq.getLayout = (page: ReactElement): ReactElement =>
  getPageLayout(page, PageType.FAQ);
